import React, { useState, useEffect, useRef } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { getData, postData } from '../../../actions/servicesHttp'
import PropTypes from 'prop-types'
import { Button } from 'primereact/button'
import '../../../css/generals/dataTable.css'
import stylesApps from '../../../css/applications/Apps.module.css'
import { secondsToString } from '../charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { popupSimple } from '../popups'

export default function DataTableLazyApps ({ editCategories, setEditCategories, category, reload, setReload, getApp, putApps, appsToPut, categories, dateFilter, editCategoryApplication, exportsCsv, exportsPdf, table, columnsExport, namePdf }) {
  const dt = useRef(null)
  const it = useRef(null)
  const { t } = useTranslation('applications')
  const navigate = useNavigate()

  //* estados de componentes
  const [loading, setLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(10)
  const [apps, setApps] = useState([])
  const [search, setSearch] = useState('')
  const [selectedFilter, setSelectedFilter] = useState('app')
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filter: 'app',
    groupApp: 'no'
  })

  const columns = [
    {
      field: 'app',
      header: t('headers.one')
    },
    /*     {
      field: 'uninstall',
      header: t('headers.two')
    }, */
    {
      field: 'totalTimeSeconds',
      header: t('headers.three')
    }
  ]

  const onReload = (set) => {
    loadLazyData()
    set(false)
  }

  useEffect(() => {
    if (reload) {
      onReload(setReload)
    }
    // eslint-disable-next-line
    }, [reload]);

  const loadLazyData = async () => {
    setLoading(true)

    let json = {}

    if (table === 'apps') {
      json = {
        groupApp: lazyParams.groupApp === 8
          ? null
          : lazyParams.groupApp !== 9
            ? lazyParams.groupApp
            : 'no',
        search: search === '' || it.current.value === ''
          ? null
          : search,
        dateFilter,
        offset: lazyParams.first,
        limit: lazyParams.rows,
        order: lazyParams.sortField === null || lazyParams.sortOrder === null
          ? ['id', 'ASC']
          : lazyParams.sortOrder === 1
            ? [lazyParams.sortField, 'ASC']
            : [lazyParams.sortField, 'DESC'],
        column: lazyParams.filter
      }
    }

    if (table === 'appsReport') {
      json = {
        groupApp: 'no',
        search: null,
        dateFilter: 0,
        exportData: true
      }
    }

    const response = await getData('applications', JSON.stringify(json), navigate)

    // console.log('respuesta del get en el DT=>', response.data)
    if (response.data?.error && response.data?.error === true) {
      setApps([])
    } else {
      const data = table === 'apps' ? response.data?.rows : response.data
      if (data && data.length === 0) {
        setApps([])
      } else if (data && data.length !== 0) {
        data.forEach((app) => {
          if (app.app.charCodeAt(0) === 65528 || app.app.charCodeAt(0) === 8291) app.app = t('dataTable.label1')
          app.groupApp = app.groupApp === null ? t('dataTable.label2') : categories[app.groupApp]?.name
          app.totalTimeSeconds = secondsToString(app.totalTimeSeconds)
        })
        setApps(data)
      }
      setTotalRecords(table === 'apps' ? response.data?.count : response.data?.length)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadLazyData()
  }, [lazyParams, category, dateFilter])

  useEffect(() => {
    setLazyParams({
      ...lazyParams,
      groupApp: category
    })
    setSearch('')
  }, [category])

  const onChangeFilterInput = (e) => {
    setSearch(e.target.value)

    if (e.target.value === '') {
      setTimeout(() => {
        loadLazyData()
      }, 1500)
    }
  }

  const onKeyUpInputText = (e) => {
    if (e.key === 'Enter') {
      loadLazyData()
    }
  }

  const onGlobalFilter = () => {
    loadLazyData()
  }

  const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      page: event.page,
      first: event.first
    })
  }

  const onSort = (event) => {
    setLazyParams({
      ...lazyParams,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    })
  }

  const onFilters = (e) => {
    setSelectedFilter(e.value)
    setLazyParams({
      ...lazyParams,
      filter: e.value
    })
  }

  const renderHeader = () => {
    const dropdownOptions = [{ label: t('headers.one'), value: 'app' }, { label: t('headers.two'), value: 'uninstall' }]

    const exportCSV = (selectionOnly) => {
      popupSimple('info', t('message8'))
      dt.current.exportCSV({ selectionOnly })
    }

    const exportPdf = async (cols, data, namePdf) => {
      popupSimple('info', t('message8'))

      const colsJson = cols.map(obj => [obj.header, obj.field])

      const json = {
        title: namePdf,
        columnName: colsJson,
        data
      }

      const handleDownload = async (url, namePdf) => {
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/pdf'
            }
          })

          if (!response.ok) {
            throw new Error('Error al descargar el archivo')
          }

          const blob = await response.blob()
          const blobUrl = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = blobUrl
          link.setAttribute('download', `${namePdf}.pdf`)
          document.body.appendChild(link)
          link.click()
          link.remove()

          window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
          console.error('Error en la descarga:', error)
        }
      }

      const res = await postData('process-pdf', json, navigate)
      if (res?.status === 200) {
        handleDownload(res.data.url, namePdf)
      } else {
        popupSimple('error', t('message9'))
      }
    }

    return (
      <div className={`containerHeader ${stylesApps.headerApps}`}>
          <div className={`${stylesApps.buttonExtract}`}>
                {exportsCsv && <Button
                  type="button"
                  icon="pi pi-file"
                  onClick={() => exportCSV(false)}
                  className={`${stylesApps.search}`}
                  data-pr-tooltip="CSV"
                />}
                {exportsPdf && <Button
                  type="button"
                  icon="pi pi-file-pdf"
                  onClick={() => exportPdf(columnsExport, apps, namePdf)}
                  className={`${stylesApps.search}`}
                  data-pr-tooltip="PDF"
                />}
                {editCategoryApplication && <Button
                  variant="dark"
                  className={`${stylesApps.button}`}
                  onClick={editCategories
                    ? () => {
                        putApps(appsToPut)
                        setEditCategories(!editCategories)
                      }
                    : () => setEditCategories(!editCategories)}
                  id="button-update-apps"
                  >
                    {editCategories ? t('dataTable.button1') : t('dataTable.button2')}
                  </Button>}
          </div>
          <div className={`${stylesApps.searchBar}`}>
            <div className={`${stylesApps.containerSearchBar}`}>
              <Button
                disabled={editCategories}
                onClick={() => onGlobalFilter()}
                className={`${stylesApps.search}`}
              >
                <i className={'pi pi-search'} />
              </Button>
              <InputText
                disabled={editCategories}
                value={search}
                onChange={(e) => onChangeFilterInput(e)}
                placeholder={t('dataTable.placeholder')}
                onKeyUp={(e) => onKeyUpInputText(e)}
                className={`p-input ${stylesApps.inputSearch}`}
                ref={it}
              />
            </div>
              {table === 'apps' && <Dropdown
                value={selectedFilter}
                options={dropdownOptions}
                onChange={onFilters}
                optionLabel="label"
                optionValue="value"
                className={`filterDropdown ${stylesApps.selectFilters}`}
              />}
          </div>
      </div>
    )
  }

  const tableHeader = renderHeader()

  const rowsPerPageDropdown = () => {
    const dropdownOptions = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 }
    ]

    const onRowsPerPageChange = (e) => {
      setSelectedRowsPerPage(e.value)
      setLazyParams({
        ...lazyParams,
        rows: e.value
      })
    }

    return (
        <div className="footerDataTable">
          <span
            className="mx-1"
            style={{ color: 'var(--text-color)', userSelect: 'none' }}
          >
            {t('dataTable.footer.label4')}
          </span>
          <Dropdown
            value={selectedRowsPerPage}
            options={dropdownOptions}
            onChange={onRowsPerPageChange}
            optionLabel="label"
            optionValue="value"
            className="rowsDropdown"
          />
          <p style={{ marginBottom: '0', fontWeight: 'normal' }}>
            {lazyParams.rows > apps.length
              ? `${t('dataTable.footer.label1')} ${apps.length} ${t('dataTable.footer.label2')} ${totalRecords}`
              : `${t('dataTable.footer.label1')} ${lazyParams.first + 1} ${t('dataTable.footer.label3')} ${
                lazyParams.first + selectedRowsPerPage
            } ${t('dataTable.footer.label2')} ${totalRecords}`}
          </p>
        </div>
    )
  }

  const onRowEditComplete = (e, id) => {
    const _apps = [...apps]
    const appFound = (element) => element.id === id
    const index = _apps.findIndex(appFound)
    _apps[index].groupApp = e.value
    const appToEdit = _apps[index]
    getApp(appToEdit)
    setApps(_apps)
  }

  const categoryEditor = (rowData) => {
    let categoriesToEdit = [t('category1'), t('category2'), t('category3'), t('category4'), t('category5'), t('category6'), t('category7'), t('category8'), t('message2')]
    if (rowData?.system === true) categoriesToEdit = [t('category2'), t('category3'), t('category4'), t('category5'), t('category6'), t('category7'), t('category8'), t('message2')]
    let category = null
    if (rowData.groupApp !== 'Sin Asignar') {
      category = categoriesToEdit.filter((element) => element === rowData.groupApp)
      category = category[0]
    }

    return (
          <Dropdown
            className='filterDropdown categoriesToEditDropdown'
            value={category}
            options={categoriesToEdit}
            onChange={(e) => onRowEditComplete(e, rowData.id)}
            placeholder={t('placeholder1')}
          />
    )
  }

  const categoryBodyTemplate = (rowData) => {
    return <Tag value={rowData.groupApp} category={rowData.groupApp} sortable={'groupApp'}></Tag>
  }

  return (
      <div className="datatable-doc-demo">
        <DataTable
            editMode="row"
            size="large"
            className="p-datatable-customers"
            ref={dt}
            exportFilename={namePdf}
            value={apps}
            lazy
            dataKey="id"
            paginator
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            rows={lazyParams.rows}
            first={lazyParams.first}
            responsiveLayout="scroll"
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={t('dataTable.emptyMessage')}
            header={tableHeader}
            footer={rowsPerPageDropdown}
        >
          {columns.map((column) => {
            return (
              <Column
                key={column.field}
                field={column.field}
                header={column.header}
                sortable={column.field !== 'totalTimeSeconds'}
                style={{ textAlign: 'center' }}
              />
            )
          })}
          {editCategories
            ? (<Column
            header={t('label2')}
            style={{ textAlign: 'center' }}
            body={categoryEditor}
          />)
            : (<Column
            key='groupApp'
            field='groupApp'
            header={t('label2')}
            sortable='groupApp'
            style={{ textAlign: 'center' }}
            body={categoryBodyTemplate}
          />)}
        </DataTable>
      </div>
  )
}

DataTableLazyApps.propTypes = {
  editCategories: PropTypes.bool,
  setEditCategories: PropTypes.func,
  category: PropTypes.number,
  reload: PropTypes.bool,
  setReload: PropTypes.func,
  getApp: PropTypes.func,
  categories: PropTypes.array,
  editCategoryApplication: PropTypes.bool,
  putApps: PropTypes.func,
  appsToPut: PropTypes.array,
  dateFilter: PropTypes.number,
  exportsCsv: PropTypes.bool,
  exportsPdf: PropTypes.bool,
  table: PropTypes.string,
  columnsExport: PropTypes.array,
  namePdf: PropTypes.string
}
